import { Key } from 'w3c-keys';

function isEscKey(eventKey) {
  return eventKey === Key.Escape || eventKey === Key.Esc;
}

export { isEscKey };
//# sourceMappingURL=keyboard.mjs.map
